<template lang="pug">
.pa-2
  v-dialog(v-model='isModalExportar'   fullscreen)
    parametros-de-exportacion(
      v-if="isModalExportar",
      preview="save"
      :tipo-predefinido="tipoArea"
      :tipoticket="tiposTicket[0]"
      @close="closeDialogExportar"
    )
  v-card
    .d-flex
      .flex-1
        v-card-title.pa-3.pl-4
          span.font-weight-700(:class="{'font-size-17' : isMovil}") Tickets abiertos
        v-card-subtitle.pb-3.font-size-12 Listado general de tickets activos
      v-switch.mx-4( v-if="perfilUsuario === 'usuario' || perfilUsuario === 'usuario-contrato'" v-model='isClosed' @change="fetch()" dense hide-details label="Cerrados")
      v-menu(v-model='showFiltros' offset-y :close-on-content-click='false'   transition="scale-transition")
        template(v-slot:activator='{ on, attrs }')
          v-btn.mt-3(:color="countFiltros ? 'primary' : 'background'" small fab='' v-bind='attrs' v-on='on')
            v-icon filter_alt
        v-card(width="550")
          v-card-text
            .d-flex
              .flex-1
                div(v-if="tipoArea !== 'sin atencion' && tipo === 'garantia'")
                  .d-flex.fd-column
                    span.font-size-12.grey--text Estados
                  estados-ticket.mb-1( v-if=" showFiltros" :tipo="tipo",  show-clear ref="estados" :codigo="estado", @selected="selectEstado")
                v-text-field( hide-details @keyup.enter="fetch()" v-model='numero' label='Numero de ticket'   type="number" @blur="addCountFiltros()")
                v-text-field( hide-details @keyup.enter="fetch()" v-model='desde' label='Desde la fecha'  type="date" @blur="addCountFiltros()")
                v-text-field( hide-details @keyup.enter="fetch()" v-model='hasta' label='Hasta la fecha'    type="date" @blur="addCountFiltros()")
                v-text-field( hide-details @keyup.enter="fetch()" v-model='codigoCliente' label='Codigo de Cliente - Interno/Sap' v-if="perfilUsuario !== 'usuario' && perfilUsuario !== 'usuario-contrato' "  type="number" @blur="addCountFiltros()")
                v-text-field( hide-details @keyup.enter="fetch()" v-model='serie' label='Serie' type="text" @blur="addCountFiltros()")
                v-radio-group.py-0(v-model='zonaGarantia' hide-details, @change="addCountFiltros()", v-if="tipo === 'garantia'")
                  template(v-slot:label='')
                    div
                      | Zona garantia
                  v-radio(value='lima' row)
                    template(v-slot:label='')
                      strong(:class="{'primary--text' : zonaGarantia === 'lima'}") Lima
                  v-radio(value='arequipa')
                    template(v-slot:label='')
                      strong(:class="{'primary--text' : zonaGarantia === 'arequipa'}") Arequipa
                  v-radio(value='sin asignacion')
                    template(v-slot:label='')
                      strong(:class="{'primary--text' : zonaGarantia === 'sin asignacion'}") Sin asignación
                v-radio-group.py-0(v-model='tipoArea' hide-details, @change="addCountFiltros()", v-if="tipo === 'garantia' && tipoDeArea === 'sin atencion'")
                  template(v-slot:label='')
                    div
                      | Area en atención
                  v-radio(value='campo')
                    template(v-slot:label='')
                      strong(:class="{'primary--text' : tipoArea === 'campo'}") Campo
                  v-radio(value='taller')
                    template(v-slot:label='')
                      strong(:class="{'primary--text' : tipoArea === 'taller'}") Taller
                  v-radio(value='sin asignacion')
                    template(v-slot:label='')
                      strong(:class="{'primary--text' : tipoArea === 'sin asignacion'}") Sin asignación
                v-switch(v-model='isUltimaAccionCliente' v-if="perfilUsuario !== 'usuario-contrato' && perfilUsuario !== 'usuario'" @change="fetch()" hide-details label='Ultima actividad por cliente')
                v-switch(v-model='isClosed' @change="fetch()" dense hide-details label="Cerrados")
              .flex-1.ml-6(v-if="esCuentaAdministrador")
                .d-flex.ai-center
                  span.font-weight-700 Cuentas relacionadas
                  v-spacer
                  v-btn(color="info" small fab='' @click="fetchGetAccountsList()" :loading="isLoadingGetAccounts")
                    v-icon sync
                .d-flex.mt-4.fd-column
                  .d-flex.ai-center(v-for='(item, i) in cuentasRelacionadas')
                    v-checkbox.ma-0(v-model='item.active' :name="item.usuario"  :id="item.usuario" color='primary'  hide-details )
                    label.font-size-11(:class="{'!primary--text font-weight-700' : item.active}" :for="item.usuario") {{ item.razonSocial}}
            v-card-actions
              v-spacer
              v-btn.mt-4(color='primary' text small :disabled="!countFiltros" v-if="!isMovil"   @click='limpiarFiltros()')
                | Limpiar
              v-btn.mt-4(color='primary' :small="!isMovil" :block="isMovil"  @click='fetch(), showFiltros = false')
                | filtrar tickets
      v-btn.ma-3.mr-3( color="primary" small fab='' @click="fetch()")
        v-icon sync
      v-btn.mt-3.mr-3( color="success" small fab='' @click="openDialogExportar()", v-if="perfilUsuario !== 'usuario-contrato' && perfilUsuario !== 'usuario'")
        v-icon import_export
      v-btn.mt-3.mr-3(color="success" v-if="!isMovil && (perfilUsuario === 'usuario' || perfilUsuario === 'usuario-contrato')" fab small @click="fetchUsuario()")
        v-icon add
      v-snackbar( absolute top v-model='isModalErrorToCreateTicket'  color="warning")
        | {{ messageError.msg }}
        template(v-slot:action='{ attrs }')
          v-btn(color='white warning--text' v-if="messageError.type === 'datos_incompletos'" small v-bind='attrs' @click="goTo('/profile')")
            | Ir a perfil
          v-btn(color='white warning--text' v-else small v-bind='attrs' @click="closeModalErrorToCreateTicket()")
            | Entendido
    .content-tickets-loading(v-if="!lista.length && isLoading")
      div(v-for="a in 15")
        v-row
          v-col(cols="12" md='6')
            v-skeleton-loader(type='list-item-avatar-two-line')
          v-col(cols="12" md='6')
        v-skeleton-loader(type='divider')
    v-sheet#data-tickets.overflow-y-auto
      div(:class="{'content-tickets' : lista.length}")
        div(
          v-infinite-scroll='fetchByScroll',
          infinite-scroll-disabled='disabledScrollExcecute',
          infinite-scroll-distance='2'
        )
          ticket-summary-info.animated.fadeInUp.faster(
            :key="index"
            v-for="(o, index) in lista"
            :ticket="o"
            @goTo="getTicketGoTo"
          )
      v-btn.floating-add(
        v-if="isMovil && (perfilUsuario === 'usuario' || perfilUsuario === 'usuario-contrato')"
        color='success'
        dark=''
        absolute=''
        large
        fab=''
        @click="fetchUsuario()"
      )
        v-icon add
    .content-tickets.d-flex.jc-center.ai-center(v-if="!lista.length && !isLoading")
      .d-flex.fd-column.jc-center.ai-center.pa-6(v-if="perfilUsuario === 'dispatcher' || perfilUsuario === 'recepcion'")
        v-icon(color="background", size="100") format_list_bulleted
        span.font-weight-700.primary--text
          | No existen tickets para mostrar
        span.text-muted.font-size-12 No se encontro ningun ticket registrado
      .d-flex.fd-column.jc-center.ai-center.pa-6(v-else)
        v-icon(color="background", size="100") clear_all
        span.font-weight-700.primary--text
          | No existen tickets para mostrar
        span.text-muted.font-size-12 No se encontraron coincidencias para esta busqueda
</template>

<script>
import { apiGet, notify }    from '../util/general'
import Router                from '../router/customer.js'
import TicketSummaryInfo     from '@/components/c_item_ticket_lista'
import estadosTicket         from '@/components/c_estados_tickets'
import parametrosExportacion from '@/components/c_reporte_parametros_exportacion'
export default {
  name      : 'ticket_list',
  components: {
    'ticket-summary-info'      : TicketSummaryInfo,
    'estados-ticket'           : estadosTicket,
    'parametros-de-exportacion': parametrosExportacion
  },
  props : {
    tipo : {
      type   : String,
      default: ''
    },
    tipoDeArea : {
      type   : String,
      default: ''
    }
  },
  data () {
    return {
      showFiltros               : false,
      showAnulados              : false,
      perfilUsuario             : localStorage.getItem('perfil'),
      username                  : localStorage.getItem('username'),
      esCuentaAdministrador     : +localStorage.getItem('esCuentaAdministrador') || 0,
      codigoCliente             : '',
      isScroll                  : false,
      lista                     : [],
      cuentasRelacionadas                     : [],
      numeroRecnum              : 0,
      disabledScrollExcecute    : false,
      noMore                    : false,
      numero                    : '',
      desde                     : '',
      hasta                     : '',
      serie                     : '',
      estado                    : 0,
      zonaGarantia              : 'sin asignacion',
      isClosed                  : false,
      isLoading                 : false,
      messageError              : {},
      isModalErrorToCreateTicket: false,
      countFiltros              : 0,
      tipoArea                  : this.tipoDeArea ||  'sin asignacion',
      isUltimaAccionCliente     : false,
      isModalExportar           : false,
      isLoadingGetAccounts           : false,
      idReporte                 : '',
      dictionary : {
        incidencia_con_equipo : 'incidencia con equipo',
        solicitud_de_insumo : 'solicitud de insumo',
        garantia : 'garantia'
      },
      tiposTicket : []
    }
  },
  created () {
    var vm = this
    if (vm.tipo === 'garantia') {
      vm.tiposTicket = ['garantia']
    } else {
      if (!vm.tipoDeArea) {
        if (vm.perfilUsuario === 'usuario-contrato') {
          vm.tiposTicket = ['incidencia con equipo', 'solicitud de insumo']
        } else if (vm.perfilUsuario === 'usuario') {
          vm.tiposTicket = ['garantia']
        } else {
          if (vm.tipo === 'garantia') {
            vm.tiposTicket = ['garantia']
          } else {
            vm.tiposTicket = ['incidencia con equipo', 'solicitud de insumo']
          }
        }
      } else {
        var tipos = vm.dictionary[vm.tipoDeArea] ? [vm.dictionary[vm.tipoDeArea]] : []
        if (!tipos.length) {
          notify(vm, 'error', 'Error', 'La categoria seleccionada es invalida')
          return
        } else {
          vm.tiposTicket = tipos
        }
      }
    }
    if (vm.esCuentaAdministrador) vm.fetchGetAccountsList(() => vm.fetch())
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  watch : {
    tipoDeArea : function (val) {
      var vm = this
      vm.isClosed = false
      if (vm.tipo === 'garantia') {
        vm.tiposTicket = ['garantia']
      } else {
        if (!vm.tipoDeArea) {
          if (vm.perfilUsuario === 'usuario-contrato') {
            vm.tiposTicket = ['incidencia con equipo', 'solicitud de insumo']
          } else if (vm.perfilUsuario === 'usuario') {
            vm.tiposTicket = ['garantia']
          } else {
            if (vm.tipo === 'garantia') {
              vm.tiposTicket = ['garantia']
            } else {
              vm.tiposTicket = ['incidencia con equipo', 'solicitud de insumo']
            }
          }
        } else {
          var tipos = vm.dictionary[vm.tipoDeArea] ? [vm.dictionary[vm.tipoDeArea]] : []
          if (!tipos.length) {
            notify(vm, 'error', 'Error', 'La categoria seleccionada es invalida')
            return
          } else {
            vm.tiposTicket = tipos
          }
        }
      }
      vm.limpiarFiltros()
    }
  },
  methods: {
    fetchGetAccountsList (callback) {
      var vm = this
      vm.isLoadingGetAccounts = true
      vm.cuentasRelacionadas = []
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener listado de cuentas' })
      var obj = {
        email    : vm.username
      }
      apiGet(vm, '/usuario/obtener/cuentas/relacionados', obj, function (data) {
        var users = data.lista.map(e => { return { ...e, active: true } })
        vm.cuentasRelacionadas = users
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoadingGetAccounts = false
        vm.$store.dispatch('transaccion', { isProceso : false })
        callback && callback()
      })
    },
    getTicketGoTo (path) {
      window.open(path, '_blank')
    },
    closeDialogExportar () {
      var vm = this
      vm.isModalExportar = false
    },
    openDialogExportar () {
      var vm = this
      if (vm.perfilUsuario === 'usuario-contrato' || vm.perfilUsuario === 'usuario') {
        alert('Bad request')
      } else {
        vm.isModalExportar = true
      }
    },
    addCountFiltros () {
      var vm = this
      vm.countFiltros = 0
      if (vm.estado) vm.countFiltros++
      if (vm.desde) vm.countFiltros++
      if (vm.hasta) vm.countFiltros++
      if (vm.serie) vm.countFiltros++
      if (vm.numero) vm.countFiltros++
      if (vm.codigoCliente) vm.countFiltros++
      if (vm.zonaGarantia !== 'sin asignacion') vm.countFiltros++
    },
    limpiarFiltros () {
      var vm = this
      vm.countFiltros = 0
      vm.estado = 0
      vm.desde = ''
      vm.hasta = ''
      vm.serie = ''
      vm.numero = ''
      vm.zonaGarantia = 'sin asignacion'
      vm.tipoArea = vm.tipoDeArea || 'sin asignacion'
      if (vm.perfilUsuario === 'dispatcher' || vm.perfilUsuario === 'recepcion') vm.codigoCliente = ''
      vm.showFiltros && vm.$refs.estados.limpiarEstado()
      vm.fetch()
    },
    closeModalErrorToCreateTicket () {
      var vm = this
      vm.isModalErrorToCreateTicket = false
      vm.messageError = {}
    },
    fetchUsuario () {
      var vm              = this
      vm.closeModalErrorToCreateTicket()
      var obj             = {
        usuario : vm.username
      }

      apiGet(vm, '/usuario/obtener', obj, function (data) {
        var datos = data.lista[0]
        if (!datos.emailConfirmado) {
          vm.messageError.msg = 'Al momento de realizar el registro de su cuenta se le envio un email de verificación, Por favor ingrese a su bandeja de email y siga las instrucciones para verficar su cuenta'
          vm.isModalErrorToCreateTicket = true
          vm.messageError.type = 'verificar_email'
          return
        }

        if (!datos.fechaCuentaActivada && datos.perfil === 'usuario-contrato') {
          vm.messageError.msg = 'Cuenta no activada, Los datos de esta cuenta todavia estan en proceso de revision.'
          vm.isModalErrorToCreateTicket = true
          vm.messageError.type = 'verificar_email'
          return
        }

        if (!datos.documento && datos.perfil === 'usuario') {
          vm.messageError.msg = 'Faltan rellenar algunos datos importantes en tu perfil, click en la siguiente opcion'
          vm.messageError.type = 'datos_incompletos'
          vm.isModalErrorToCreateTicket = true
          return
        }

        if (!datos.ruc && datos.perfil === 'usuario-contrato') {
          vm.messageError.msg = 'Faltan rellenar el RUC, click en la siguiente opcion'
          vm.messageError.type = 'datos_incompletos'
          vm.isModalErrorToCreateTicket = true
          return
        }

        if (datos.perfil === 'usuario') vm.goTo('/ticket/nuevo')
        else vm.goTo('/ticket-contrato/nuevo')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    goTo (page) {
      Router.push(page)
    },
    selectEstado (e) {
      var vm = this
      vm.estado = e.codigo
      vm.addCountFiltros()
    },
    fetchByScroll () {
      var vm = this
      vm.isScroll = true
      vm.fetch()
    },
    fetch () {
      var vm = this
      console.log('Entro a fetch....')
      var url = 'ticket/obtener'
      vm.isLoading = true
      vm.showFiltros = false
      if (!vm.isScroll) {
        vm.lista = []
        vm.numeroRecnum = 0
      }
      vm.disabledScrollExcecute = true
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo listado de tickets' })
      vm.noMore                 = false
      if (!vm.tiposTicket.length) {
        notify(vm, 'error', 'Error', 'Los parametros son invalidos')
        return
      }
      console.log('vm.cuentasRelacionadas', vm.cuentasRelacionadas)
      var cuentas = vm.cuentasRelacionadas.filter(e => e.active).map(e => e.usuario)
      var obj = {
        numero               : vm.numero,
        desde                : vm.desde,
        hasta                : vm.hasta,
        serie                : vm.serie,
        estado               : vm.estado,
        codigoCliente        : vm.codigoCliente,
        isClosed             : vm.isClosed,
        tipoTicket           : vm.tiposTicket,
        tipoArea             : vm.tipoArea,
        zonaGarantia         : vm.zonaGarantia,
        numeroRecnum         : vm.numeroRecnum,
        isUltimaAccionCliente: vm.isUltimaAccionCliente,
        cuentasRelacionados  : cuentas,
        cantidadRegistros    : 20
      }

      console.log('obkj', obj)

      apiGet(vm, url, obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i])
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExcecute = true
        } else {
          vm.numeroRecnum = data.numeroRecnum
          vm.disabledScrollExcecute = false
        }
      }, function (err) {
        vm.disabledScrollExcecute = true
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.isScroll  = false
        vm.$store.dispatch('transaccion', { isProceso : false })
        vm.isLoading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.content-tickets-loading
  min-height: calc(100vh - 137px)
  max-height: calc(100vh - 137px)
  height    : calc(100vh - 137px)
.content-tickets
  // min-height: calc(100vh - 146px)
  // max-height: calc(100vh - 146px)
  // height    : calc(100vh - 146px)
  height    : calc(100vh - 137px)
.position
  z-index 1
.estado-dot
  cursor pointer
.floating-add
  bottom: 26px;
  right: 26px;
</style>



// WEBPACK FOOTER //
// View_tickets.vue?4cdd446f